import Grid from "../Grid/grid";
import Title from "../title";
import { motion } from "framer-motion";
import technologiesData from "./data/technologies-data";

function TechnologiesShowcase() {
    // Flatten all technologies for a marquee-style showcase
    const allTech = technologiesData.flatMap((cat) => cat.technologies);
    const half = Math.ceil(allTech.length / 2);
    const rowOne = allTech.slice(0, half);
    const rowTwo = allTech.slice(half);

    return (
        <section className="w-full h-full relative flex flex-col overflow-hidden p-2 lg:p-16">
            <Grid size={100} direction="top-center" />

            <div className="z-10 flex justify-start items-start mb-12 w-full">
                <Title title="One Team. Every Technology." />
            </div>

            <div className="z-10 max-w-4xl mb-12">
                <h2 className="md:text-4xl text-xl font-medium md:font-light text-gray-900 leading-tight">
                    40+ technologies. Zero context-switching for you.
                </h2>
                <p className="mt-4 text-gray-600 md:text-lg max-w-3xl">
                    Whatever your product needs — web, mobile, AI, cloud — our
                    cross-functional team already has the expertise in-house.
                </p>
            </div>

            {/* Marquee rows */}
            <div className="relative z-10 flex flex-col gap-6 py-8">
                {/* Fade gradients on the sides */}
                <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-white to-transparent z-20 pointer-events-none" />
                <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-white to-transparent z-20 pointer-events-none" />

                <div className="overflow-hidden">
                    <motion.div
                        className="flex gap-6 w-max"
                        animate={{ x: ["0%", "-50%"] }}
                        transition={{
                            duration: 40,
                            repeat: Infinity,
                            ease: "linear",
                        }}
                    >
                        {[...rowOne, ...rowOne].map((tech, i) => (
                            <div
                                key={`row1-${i}`}
                                className="flex items-center gap-3 px-6 py-4 rounded-2xl bg-white border border-gray-100 shadow-sm min-w-fit"
                            >
                                <img
                                    src={tech.logo}
                                    alt={tech.name}
                                    className="w-8 h-8 object-contain"
                                />
                                <span className="text-gray-800 font-medium whitespace-nowrap">
                                    {tech.name}
                                </span>
                            </div>
                        ))}
                    </motion.div>
                </div>

                <div className="overflow-hidden">
                    <motion.div
                        className="flex gap-6 w-max"
                        animate={{ x: ["-50%", "0%"] }}
                        transition={{
                            duration: 40,
                            repeat: Infinity,
                            ease: "linear",
                        }}
                    >
                        {[...rowTwo, ...rowTwo].map((tech, i) => (
                            <div
                                key={`row2-${i}`}
                                className="flex items-center gap-3 px-6 py-4 rounded-2xl bg-white border border-gray-100 shadow-sm min-w-fit"
                            >
                                <img
                                    src={tech.logo}
                                    alt={tech.name}
                                    className="w-8 h-8 object-contain"
                                />
                                <span className="text-gray-800 font-medium whitespace-nowrap">
                                    {tech.name}
                                </span>
                            </div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </section>
    );
}

export default TechnologiesShowcase;
